import React from 'react'
import styled from 'styled-components'
import { LabelContainer } from '../../shared.styles'
import { formatCurrency } from '../../../helpers'

const ProductContainer = styled.div`
  padding: 12px 0px 12px 0px;
  display: flex;
  flex-wrap: wrap;
`

const Product = ({ label, value }) => {
  return (
    <div>
      <ProductContainer>
        <LabelContainer>
          <h6>{label}</h6>
        </LabelContainer>
        {formatCurrency(value)}
      </ProductContainer>
    </div>
  )
}

export default Product
